import { Component } from 'src/utils';
import template from './store-promo.html';
// import promoImagePlaceholder from './../../../images/store_promo_placeholder.png';

@Component({
  controllerAs: 'ctrl',
  template
})

export default class storePromo {

  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'authService',
    '$cookies',
    '$sce',
    '$window'

  ];

  constructor($scope, $ngRedux, $state, $auth, $cookies,$sce, $window) {
    this.$sce=$sce;
    this.$window = $window;
    // this.promoImagePlaceholder = promoImagePlaceholder;
    const disconnect = $ngRedux.connect(this.mapState)(this);
   
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    let obj = {
      profile: state.auth.profile,
      list: state.order.categories
    };
    if (!obj.profile.store) {
      obj.profile = { 'store': state.auth.storeDetail };
    }
    return obj;
  }

  deliberatelyTrustDangerousSnippet = function (data) {
   
    return this.$sce.trustAsHtml(data);
  };

  getImageHeight() {
    var shippingImageHeight = document.getElementById('store_promo_img').clientHeight;
    // var titleHeight =document.getElementById('store-promo-head').clientHeight; 
    return (shippingImageHeight)+'px';
  }
  getDescHeight() {
    var shippingImageHeight = document.getElementById('store_promo_img').clientHeight;
    // var titleHeight =document.getElementById('store-promo-head').clientHeight; 
    return (shippingImageHeight - 120)+'px';
  }
  getBodyHeight() {
    var shippingImageHeight = document.getElementById('store_promo_img').clientHeight;
    return (shippingImageHeight - 53)+'px';
  }

  isIpad() {
   
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/store-promo/store-promo.js